import escapeRegExp from "lodash/escapeRegExp";
import * as actions from "../../store/viewmodel/actions";
import { logBrowseFilterClicked } from "../../util/analytics";
import { scrollToElement } from "../../util/viewport-utils";

export const handleAlphaTabClick = (
  event,
  dispatch,
  alphaTabClicked,
  activeAlphaTab,
  history,
  location,
  setActiveAlphaTab,
  slug,
  rootElementId,
  stickyWrapperId,
  setSearchKey
) => {
  const {
    functionArgs: { alphaTab, shouldFetchViewModelOnClick, telemetryData },
  } = alphaTabClicked;
  event.preventDefault();
  const { pathname, search } = location;
  let searchToUse = search;
  const characterFrom = activeAlphaTab;
  setActiveAlphaTab(alphaTab);
  logBrowseFilterClicked({ ...telemetryData, characterFrom });

  if (shouldFetchViewModelOnClick) {
    actions.getViewmodel(dispatch, slug, alphaTab);
    searchToUse = "";
    setSearchKey(undefined);
  } else {
    const rootElement = document.getElementById(rootElementId);
    const distance = rootElement.getBoundingClientRect().top;
    const scrollOffset = distance >= 0 ? distance : 0;
    scrollToElement(alphaTab, stickyWrapperId, scrollOffset);
  }
  history.push(`${pathname}${searchToUse}#${alphaTab}`);
};

export const filterList = (
  fullList,
  fullAlphaTabs,
  searchKey,
  selectedPopulation,
  dispatch,
  shouldRetrieveAllContentForPubType
) => {
  let listToSet = fullList || [];
  let filteredAlphaTabs = fullAlphaTabs || [];
  if (searchKey) {
    const searchRegExp = new RegExp(escapeRegExp(searchKey), "i");

    listToSet = listToSet
      .map((group) => ({
        ...group,
        results: group.results
          .filter((item) => searchRegExp.test(item.label))
          .map((item) => ({
            ...item,
            label: item.label.replace(
              searchRegExp,
              (match) => `<mark>${match}</mark>`
            ),
          })),
      }))
      .filter((group) => !!group.results?.length);
  }
  if (selectedPopulation) {
    listToSet = listToSet
      .map((group) => ({
        ...group,
        results: group.results.filter((item) =>
          item.population.some(
            (value) => value.toLowerCase() === selectedPopulation.toLowerCase()
          )
        ),
      }))
      .filter((group) => !!group.results?.length);
  }
  if (shouldRetrieveAllContentForPubType) {
    filteredAlphaTabs = fullAlphaTabs
      .map((alphaTab) => {
        const alphaTabGroup = listToSet.find(
          (group) => group.label === alphaTab.label
        );
        return alphaTabGroup ? alphaTab : null;
      })
      .filter((alphaTab) => alphaTab);
  }

  actions.setFilteredList(dispatch, listToSet, filteredAlphaTabs);
};
